<template>
    <div class="ds-settings-lunch-item">
        <div>
            <div class="text-xs text-gray">Продолжительность смены (мин.)</div>
            <div class="flex text-sm items-end text-gray">
                <div class="mr-1 pb-0.5">от</div><base-input class="w-20 mr-3" v-model="fromTime" :disabled></base-input>
                <div class="mr-1 pb-0.5">до</div><base-input v-model="shiftTime" max-length="5" class="w-20" type="number"
                @input="onChanges"></base-input>
            </div>
        </div>
        <div><base-input v-model="breakTime" max-length="5" type="number" class="w-24"
                @input="onChanges">Перерыв (мин.)</base-input></div>
        <button type="button" class="ds-settings-lunch-action" @click="edit" :disabled="isDisabled"><icon><IconApprove /></icon></button>
        <button type="button" class="ds-settings-lunch-action ds-settings-lunch-action-danger" @click="onDelete"><icon><IconTrash /></icon></button>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import IconTrash from '@/ui/icons/IconTrash.vue'
import IconApprove from '@/ui/icons/IconApprove.vue'
import debounce from 'lodash.debounce'

const emit = defineEmits(['edit', 'delete'])

interface Lunch {
    id: string,
    shift_duration_seconds: string | number,
    break_duration_seconds: string | number
}

interface Props {
    lunch: Lunch,
    prev: Lunch | null,
    next: Lunch | null
}

const isDisabled = ref(true)
const { lunch, prev, next } = defineProps<Props>()
const fromTime = ref(0)
const shiftTime = ref(+lunch.shift_duration_seconds/60)
const breakTime = ref(+lunch.break_duration_seconds/60)
const disabled = true

if(prev) fromTime.value = +prev.shift_duration_seconds/60

const onChanges = debounce(() => {
      isDisabled.value = !(shiftTime.value !== lunch.shift_duration_seconds || breakTime.value !== lunch.break_duration_seconds) 
    if(next && shiftTime.value > +lunch.shift_duration_seconds/60) shiftTime.value = +lunch.shift_duration_seconds/60
    if(prev && shiftTime.value <= +prev.shift_duration_seconds/60) shiftTime.value = +prev.shift_duration_seconds/60 + 1
    if(shiftTime.value <= 0) shiftTime.value = 1
}, 500) 

const edit = () => {
    if(isDisabled.value) return

    const data = {
        id: lunch.id,
        shift_duration_seconds: shiftTime.value * 60,
        break_duration_seconds: breakTime.value * 60
    }
    emit('edit', data)
    isDisabled.value = true
}

const onDelete = () => {
     emit('delete', lunch.id)
}
</script>
